.panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-4);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  text-align: center;
}

.header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--tuna-spacing-3);
  width: 100%;
}

.title {
  margin: 0;
  font-size: var(--tuna-typography-h6-fontSize);
}

.title:focus {
  outline: none;
}

.title:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.position,
.subLabel,
.line,
.hint {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-muted);
}

.lines {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}

.roll {
  width: 100%;
  max-width: 360px;
}

.status {
  font-weight: 600;
}

.progress {
  width: 100%;
  max-width: 360px;
  height: 4px;
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-palette-action-hover);
  overflow: hidden;
}

.fill,
.fillRunning {
  display: block;
  height: 100%;
  background: var(--tuna-palette-primary-main);
  transform-origin: left;
  transform: scaleX(0);
}

.fillRunning {
  animation: fill var(--capture-ms) linear forwards;
}

@keyframes fill {
  to {
    transform: scaleX(1);
  }
}

/* Joni §5: a static fill under reduced motion */
@media (prefers-reduced-motion: reduce) {
  .fillRunning {
    animation: none;
    transform: scaleX(1);
    opacity: 0.4;
  }
}

.actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--tuna-spacing-2);
}

.actions > * {
  min-height: 44px;
}
